// Group the presentation only. Every variant retains its original product and price IDs.
export function catalogVariant(product) {
  const match = product.kind === "membership" && product.title.match(/^(.*),\s*([1-9]\d*)\s+Raten?$/i)
  return { title: match ? match[1].trim() : product.title, count: match ? Number(match[2]) : 0,
    label: match ? `${Number(match[2])} Raten` : "Einmalzahlung" }
}

export function catalogFamilies(products) {
  const buckets = new Map()
  for (const product of products) {
    const variant = catalogVariant(product), key = JSON.stringify([product.brandId, product.kind, variant.title.toLocaleLowerCase("de-CH")])
    if (!buckets.has(key)) buckets.set(key, [])
    buckets.get(key).push({ ...product, paymentCount: variant.count, paymentLabel: variant.label, familyTitle: variant.title })
  }
  const families = []
  for (const [key, entries] of buckets) {
    // Ambiguous duplicate variants remain separate; grouping must never imply equivalence.
    const groups = new Set(entries.map(entry => entry.paymentCount)).size === entries.length ? [entries] : entries.map(entry => [entry])
    for (const group of groups) {
      group.sort((a, b) => a.paymentCount - b.paymentCount)
      families.push({ id: key + group[0].id, title: group.length > 1 ? group[0].familyTitle : group[0].title,
        brandId: group[0].brandId, variants: group, primary: group[0],
        studioCount: new Set(group.flatMap(entry => entry.studioIds || [])).size || Math.max(...group.map(entry => entry.studioCount || 0)) })
    }
  }
  return families.sort((a, b) => a.title.localeCompare(b.title, "de-CH"))
}

export function durationOrder(duration) {
  return (duration.years || 0) * 365 + (duration.months || 0) * 30 + (duration.days || 0)
}

export function orderedPrices(groups, durations) {
  const term = id => durations.find(entry => entry.id === id) || {}
  return [...groups].sort((a, b) => durationOrder(term(a.durationId)) - durationOrder(term(b.durationId)) || a.priceCents - b.priceCents || a.feeCents - b.feeCents)
}

export function catalogPrice(product, durations) {
  const prices = orderedPrices(product.prices || [], durations)
  const annual = prices.filter(price => {
    const term = durations.find(entry => entry.id === price.durationId) || {}
    return ((term.years || 0) * 12 + (term.months || 0)) === 12 && !term.days
  })
  const shown = annual.length ? annual : prices.filter(price => price.durationId === (prices[0] || {}).durationId)
  return shown.length ? { ...shown[0], varies: new Set(shown.map(price => price.priceCents)).size > 1 } : null
}
